import React, { useState } from "react";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as IconWrapper from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Styles from "./styles/Summary";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import useSummaryExtra from "../../../hooks/shared/extras/useSummaryExtra";
import CategorizedExtras from "../common/extras/CategorizedExtras";
import MiniCarHero from "../common/MiniCarHero";
import Container from "../common/styles/Container";
import SummarySpecs from "./SummarySpecs";
import useInitSummary from "../../../hooks/summary/useInitSummary";
import SidebarWrapper from "../../../../../../common-deprecated/components/SidebarWrapper";
import Basket from "../common/basket/Basket";
import SummaryTotalPanel from "./SummaryTotalPanel";
import BottomNavigation from "../common/nav/BottomNavigation";
import SummaryDetails from "./SummaryDetails";
import { useBnbSelector } from "../../../redux/store";
import BasketFinanceTogglePanel from "../common/basket-financetoggle-panel/BasketFinanceTogglePanel";
import { NAV_PRIMARY_HEIGHT } from "../../../../../../common-deprecated/styles/v2/lexus/components/Navigation";
import { BASKET_HEADER_TOP_MARGIN } from "../common/basket/styles/Basket";
import { isPassiveSummary } from "../../../utils/settings/bnbSettingUtils";

const SummaryContainer = (): JSX.Element => {
    useInitSummary();

    const { categories, removeExtra, basketExtras } = useSummaryExtra();
    const [showExtras, setShowExtras] = useState(true);

    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const passiveSummary = isPassiveSummary(commonSettings);

    const genericePriceDisclaimerSummary = useBnbOptionalLabel("genericPriceDisclaimerSummary");

    return (
        <>
            <Container mt={{ _: 5, lg: "60px" }}>
                <MiniCarHero />
            </Container>
            <Styles.Divider />
            <Container>
                <Flex.Row justifyContent="flex-start">
                    <Flex.Col width={{ xs: 1, lg: 2 / 3 }} pt={5}>
                        <SummaryDetails />
                        {basketExtras.length ? (
                            <>
                                <Styles.Title pt={3} pb={2} collapsible onClick={() => setShowExtras(!showExtras)}>
                                    <Type.Strong m={0}>
                                        <BnbLabel label="extras" />
                                        <span>{` (${basketExtras.length})`}</span>
                                    </Type.Strong>
                                    <IconWrapper.ToggleIconWrapper isDown={showExtras}>
                                        <Icon variant="chevronDown" />
                                    </IconWrapper.ToggleIconWrapper>
                                </Styles.Title>
                                <Styles.Panel visible={showExtras}>
                                    {categories.map((category) => (
                                        <CategorizedExtras
                                            key={category.id}
                                            categorizedExtra={category}
                                            basketExtras={basketExtras}
                                            onRemoveExtra={removeExtra}
                                            handleClickOnlyOnIcon
                                            alwaysShowAllExtras
                                            allowRemoving={!passiveSummary}
                                        />
                                    ))}
                                </Styles.Panel>
                            </>
                        ) : null}
                        <SummaryTotalPanel />
                        <SummarySpecs />
                        {/* TODO: @bySebastian how to put whitespace here without changing components? */}
                        <Flex.Col mt={4} />
                        <BottomNavigation />
                    </Flex.Col>
                    {/* Basket */}
                    <Flex.Col display={{ xs: "none", lg: "block" }} width={1 / 3} position="relative" pt={5}>
                        <SidebarWrapper top={NAV_PRIMARY_HEIGHT} paddingTop={BASKET_HEADER_TOP_MARGIN}>
                            <BasketFinanceTogglePanel cashPriceDisclaimer={genericePriceDisclaimerSummary} />
                            <Basket cashPriceDisclaimer={genericePriceDisclaimerSummary} />
                        </SidebarWrapper>
                    </Flex.Col>
                </Flex.Row>
            </Container>
            <Container>
                <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
            </Container>
        </>
    );
};

export default SummaryContainer;
